module.exports = __webpack_public_path__ + "img/humidity.7d71d15c.png";